import { Loading } from '@/shared/ui';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { GuidelinesWorkspace } from '@/features/guidelines';

export const VisualGuidelines = () => {
  const workspaceId = useCurrentWorkspaceId();

  if (!workspaceId) {
    return <Loading />;
  }

  return <GuidelinesWorkspace />;
};

VisualGuidelines.displayName = 'VisualGuidelines';
